import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { BrowserSessionService } from '../../services/browser-session.service';
import { AuthenticationService } from '../../services/authentication.service';

export function browserSessionInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const browserSessionService = inject(BrowserSessionService);
  const authenticationService = inject(AuthenticationService);

  if (authenticationService.isUserConnected() && authenticationService.isUrlInAuthorizedUrls(req.url)) {
    req = addBrowserSessionIdHeader(req, browserSessionService.sessionId);
  }

  return next(req);
}

function addBrowserSessionIdHeader(req: HttpRequest<unknown>, browserSessionId: string) {
  return req.clone({ setHeaders: { 'X-Browser-Session-Id': browserSessionId } });
}
